import DealRadarComponent from "../components/deal-radar";

export default function DealRadar() {
  return <DealRadarComponent />;
}
